import React from 'react'

import { MentionControlProjectTeamFragment as SuggestionUser } from '~/common/types/graphql'
import { MergeTagValueType, MergeTagType } from '~/common/types/merge-tags'
import { RichTextEditor } from '~/views/components/RichTextEditor'
import {
  RightToolbar,
  StyledToolbar,
} from '~/views/components/RichTextEditor/components'
import {
  LinkControl,
  ListStyleControl,
  TextStyleControl,
  ImageControl,
  MergeTagControl,
  MentionControl,
  EmojiControl,
} from '~/views/components/RichTextEditor/components/controls'

interface Props {
  value: string
  mergeValues: MergeTagValueType
  mergeTags?: MergeTagType[]
  mentions?: SuggestionUser[]
  dataTestId?: string
}

const RichTextView2 = ({
  value,
  mergeValues,
  mergeTags = [],
  mentions = [],
  dataTestId,
}: Props) => {
  return (
    <RichTextEditor initialValue={value} isReadOnly dataTestId={dataTestId}>
      <StyledToolbar>
        <RightToolbar>
          <MergeTagControl mergeValues={mergeValues} mergeTags={mergeTags} />
          <TextStyleControl />
          <ListStyleControl />
          <LinkControl />
          <ImageControl />
          <EmojiControl />
          <MentionControl
            projectTeam={mentions.filter(
              (mention) => mention.firstName && mention.lastName,
            )}
          />
        </RightToolbar>
      </StyledToolbar>
    </RichTextEditor>
  )
}

export default RichTextView2
